<template>
  <div>
    <LoadingComponent v-show="checkLoading"></LoadingComponent>
    <v-container>

      <RoalertComponent v-show="isError">
        <div>{{ errorMessage }}</div>
      </RoalertComponent>

      <div v-if="!openpdfbox">
        <h2 class="primary--text d-flex">
          {{ formName }}
          <v-spacer></v-spacer>
          <div v-if="placowka">
            <v-btn small color="error" elevation="0" class="mb-5" @click="returnToSelect">powrót</v-btn>
          </div>
        </h2>
      </div>

      <div v-if="placowka">
      <p class="mb-15">{{ placowka.name }}, {{ placowka.adres }}</p>

      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
      <v-row class="mb-5">
        <v-col cols="12" xs="12" sm="6">
          <v-text-field
            outlined tile
            v-model="pacjent.imie"
            :rules="[rules.name, rules.requiredImie, rules.max50]"
            label="Imię Świadczeniobiorcy*"
            class="rounded-0"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6">
          <v-text-field
            outlined tile
            v-model="pacjent.nazwisko"
            :rules="[rules.name, rules.requiredNazwisko, rules.max50]"
            label="Nazwisko Świadczeniobiorcy*"
            class="rounded-0"
          ></v-text-field>
        </v-col>
      </v-row>

      <h4 class="primary--text mb-6">Adres zamieszkania</h4>
      <v-row>
        <v-col cols="12" xs="12" sm="6">
          <v-text-field
            outlined tile
            v-model="pacjent.ulica"
            :rules="wymaganyAdres"
            label="Ulica*"
            class="rounded-0"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="6" sm="3">
          <v-text-field
            outlined tile
            v-model="pacjent.nrDomu"
            :rules="wymaganyDom"
            label="Nr domu*"
            class="rounded-0"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="6" sm="3">
          <v-text-field
            outlined tile
            v-model="pacjent.nrMieszkania"
            :rules="[rules.mieszkanie]"
            label="Nr mieszkania"
            class="rounded-0"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row class="mb-15">
        <v-col cols="12" xs="5" sm="3">
          <v-text-field
            outlined tile
            v-model="pacjent.kod"
            :rules="wymaganyKod"
            label="Kod pocztowy*"
            class="rounded-0"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="7" sm="6">
          <MiastoComponent @city="handleCity" />
        </v-col>
      </v-row>

      <v-row class="mb-5">
        <v-col cols="12" xs="12" sm="3">
          <v-text-field
            outlined tile
            v-model="pacjent.pesel"
            :rules="wymaganyPesel"
            :label="peselRquired?'PESEL*':'PESEL'"
            class="rounded-0"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="3">
          <v-text-field
            outlined tile
            v-model="pacjent.telefon"
            :rules="wymaganyTelefon"
            prefix="+48"
            label="Telefon kontaktowy*"
            class="rounded-0"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6">
          <v-text-field
            outlined tile
            v-model="pacjent.haslo"
            :rules="wymaganeHaslo"
            class="rounded-0"
            label="Hasło do udzielania informacji przez telefon*"
          ></v-text-field>

        </v-col>
      </v-row>
      <v-divider></v-divider>
      <div id="zgody">
        <div class="mb-5 pt-5 pb-5" v-for="(item, index) in zgody" :key="item.id">
          <b>{{ index+1 }}.</b> {{ item.content }}
          <v-divider></v-divider>
        </div>
      </div>

    <v-row class="mb-6">
      <v-col cols="12" xs="12" sm="4">
        <v-text-field
            outlined tile
            class="rounded-0"
            v-model="pacjent.email"
            :rules="wymaganyEmail"
            label="Adres e-mail*"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-divider></v-divider>
    <div id="oswiadczenia">
      <div v-for="(item, index) in oswiadczenia" :key="item.id">
        <v-row>
            <v-col cols="3" sm="2" md="1" class="text-center">
              <v-checkbox
                v-model="item.checked"
                @change="changeCheckout(item, index)"
              ></v-checkbox>
            </v-col>
            <v-col xs="8" sm="10" md="11" class="pt-6">
              <b>{{ index+1 }}.</b> {{ item.content }}
              <div v-if="item.wymagaj > 0" class="pt-5">
                  <v-text-field
                    outlined tile
                    v-model="item.danepacName"
                    :rules="[rules.name]"
                    label="Imię i nazwisko upoważnionego"
                    class="rounded-0"
                  ></v-text-field>
                  <v-row>
                    <v-col>
                      <v-select
                        :items="typyDanych"
                        outlined tile
                        label=""
                        v-model="item.danpacType"
                        class="rounded-0"
                      ></v-select>
                    </v-col>
                     <v-col>
                        <v-text-field
                          v-show="czyTypPesel(item.danpacType)"
                            v-model="item.danepacPesel"
                            :rules="[rules.pesel]"
                            label="PESEL"
                            outlined tile
                            class="rounded-0"
                        ></v-text-field>

                        <div v-show="!czyTypPesel(item.danpacType)">
                          <DataurComponent :index="index" @dataur="handleDataur" />
                        </div>


                      </v-col>
                      <v-col>
                        <v-text-field
                            v-model="item.danepacTelefon"
                            :rules="[rules.telefon]"
                            label="Telefon kontaktowy"
                            prefix="+48"
                            hint="(opcjonalnie)"
                            outlined tile
                            class="rounded-0"
                        ></v-text-field>
                      </v-col>
                  </v-row>
              </div>
            </v-col>
        </v-row>
        <v-divider></v-divider>
      </div>
    </div>

    <div class="pt-10">
    {{ currentCity }}, {{ currentDate }}
    </div>

    <div class="pt-15 pb-15">
      <v-btn block large color="success" elevation="0"
       :disabled="!valid"
        @click="validate"
        :loading="sending"
      >Wyślij</v-btn>
    </div>

    </v-form>
    </div>

    <div v-else >

      <div v-if="openpdfbox">
        <v-sheet
        color="white"
        elevation="3"
        max-width="500"
        class="pa-10 mt-15"
        style="margin: 0 auto;"
      >
        <h3 class="mb-10 text-center primary--text">Dziękujemy, Twoje dane zostały wysłane do placówki medycznej i oczekują na weryfikację.</h3>
        <div class="text-center pt-30"><v-btn large elevation="0" @click="downloadPdf(formToken)" :disabled="downloaded" color="success">Pobierz oświadczenie</v-btn></div>
      </v-sheet>

      </div>

      <v-sheet
        color="white"
        elevation="3"
        max-width="500"
        class="pa-10 mt-15"
        style="margin: 0 auto;"
        v-else
      >
      <h3 class="mb-8">Twoja placówka medyczna</h3>
      <v-select
        v-model="placowka"
          :items="placowki"
          dense
          return-object
          item-text="name"
          item-value="id"
          no-data-text="Nie odnaleziono placówek medycznych"
          @change="placSelected"
          label="Wybierz swoją placówkę medyczną"
      ></v-select>
      </v-sheet>

    </div>

    </v-container>
  </div>
</template>

<script>
import MiastoComponent from './MiastoComponent.vue';
import DataurComponent from './DataurComponent.vue';
import RoalertComponent from './RoalertComponent.vue';
import LoadingComponent from './LoadingComponent.vue';
export default {
  name: 'FormularzComponent',
  components: {
    MiastoComponent,
    LoadingComponent,
    RoalertComponent,
    DataurComponent,
  },
  props: {

  },
  data: () => ({
    formId: '',
    formName: '',
    valid: true,
    sending: false,
    placowka: false,
    openpdfbox: false,
    pdf: '',
    placowki: [],
    downloaded: false,
    downloadLink: null,
    peselRequired: false,
    pacjent: {
      imie: '',
      nazwisko: '',
      ulica: '',
      nrDomu: null,
      nrMieszkania: null,
      kod: null,
      miasto: null,
      miastoId: null,
      pesel: null,
      telefon: null,
      haslo: null,
    },
    typyDanych: [
        'podaję PESEL',
        'podaję datę urodzenia',
      ],
    activePicker: null,
    menu: false,
    zgody: [],
    oswiadczenia: [],
    wymagane: [],
    loading: true,
    error: false,
    errorMessage: '',
    currentCity: '',
    currentDate: '',
    rules: {
        min8: value => value && value.length >= 8 || 'Hasło musi zawierać min. 8 znaków',
        max50: value => value && value.length <= 50 || 'Maksymalnie 50 znaków',
        requiredImie: value => !!value || 'Imię jest wymagane.',
        requiredNazwisko: value => !!value || 'Nazwisko jest wymagane.',
        requiredPassport: value => !!value || 'Wymagany numer i seria paszportu',
        required: value => !!value || 'Pole jest wymagane.',
         dom() { return true; },
          mieszkanie() { return true; },
          name: value => {
            if (!value) return true;
            const pattern = /^[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ \-]{0,50}$/;
            return pattern.test(value) || 'Użyto niedozwolonych znaków';
          },
          pesel: value => {
            if (!value) return true;
            const pattern = /^[[0-9]{11}$/;
            return pattern.test(value) || 'Błędny PESEL';
          },
          kod: value => {
            const pattern = /^[0-9]{2}[-][0-9]{3}$/;
            return pattern.test(value) || 'Błędny kod pocztowy';
          },
          dataur: value => {
            if (!value) return true;
            const pattern = /^[0-9]{4}[-][0-9]{2}[-][0-9]{2}$/;
            return pattern.test(value) || 'Nieprawidłowy format daty';
          },
          telefon: value => {
            if (!value) return true;
            const pattern = /^[0-9]{9}$/;
            return pattern.test(value) || 'Nieprawidłowy numer telefonu';
          },
          counter: value => value.length <= 20 || 'Max 20 characters',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Nieprawidłowy adres e-mail'
          },
    },

  }),
   computed: {
     formToken() { return this.token; },
    checkLoading() { return this.loading; },
    isError() { return this.error; },
    wymaganyAdres() {
      if (this.wymagane['adres'] === 1) return [this.rules.required, this.rules.max50];
      return [this.rules.max50];
    },
    wymaganyDom() {
      if (this.wymagane['adres'] === 1) return [this.rules.required, this.rules.dom];
      return [this.rules.dom];
    },
    wymaganyKod() {
      if (this.wymagane['adres'] === 1) return [this.rules.required, this.rules.kod];
      return [this.rules.kod];
    },
    wymaganyPesel() {
      if (this.peselRequired) return [this.rules.pesel, this.rules.required];
      return [this.rules.pesel];
    },
    wymaganyEmail() {
      if (this.wymagane['email'] === 1) return [this.rules.email, this.rules.required];
      return [this.rules.email];
    },
    wymaganyTelefon() {
      if (this.wymagane['telefon'] === 1) return [this.rules.telefon, this.rules.required];
      return [this.rules.telefon];
    },
    wymaganeHaslo() {
      if (this.wymagane['haslo'] === 1) return [this.rules.min8, this.rules.required]
      return [this.rules.min8];
    },
   },

   mounted() {
     this.initialize();
   },

    watch: {
      menu (val) {
        console.log(this.activePicker);
        val && setTimeout(() => (this.activePicker = 'YEAR'));
      },
    },
   methods: {
     initialize() {
       this.$api
      .getData(`/formularz/getformplaces`)
      .then(response => {
          this.addPlaces(response.data);
          this.loading = false;
          })
      .catch(error => { console.log(error); this.loading = false; this.showSnackBar('Coś poszło nie tak...');
      });
     },
     getUpowazniony() {
       let upowazniony = {};
       let osws = [];
       this.oswiadczenia.forEach(obj => {
         osws.push({id: obj.id, checked: obj.checked})
         if (obj.wymagaj > 0) {
            upowazniony = {
             imie: obj.danepacName,
             type: obj.danepacType,
             pesel: obj.danepacPesel,
             dataur: obj.danepacDataur,
             telefon: obj.danepacTelefon,
           };
         }
       });
       return {upowazniony: upowazniony, oswiadczenia: osws}
     },
     scrollTop() {
       window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
     },
     changeCheckout(item, index) {       
       if (item.checked) {         
         let wykluczajace = item.wyklucz;         
         wykluczajace.forEach(val => {           
           if (val>0 && val!=item.id) {
             let targetIndex = this.findIndexOf(this.oswiadczenia, val);             
             if (targetIndex >= 0) {               
                this.oswiadczenia[targetIndex].checked = false;
             }
           }
         });
       }
     },
     addPlaces(places) {
       this.placowki = [];
       for (let key in places) {
        this.placowki.push({ id: places[key].plac_id, name: places[key].plac_nazwa, adres: places[key].plac_miasto + ' ' + places[key].plac_ulica });
       }

     },
     validate () {
       const validationResult = this.$refs.form.validate();
        if (this.checkZgody(this.zgody.length) && this.checkOsw(this.oswiadczenia.length) && validationResult) {   
            this.errorMessage = '';
            this.error = false;          
            this.sendForm();
        } else {
          if (!(validationResult)) {
            this.errorMessage = 'Popraw zaznaczone błędy.';
            this.error = true;  
          }
          this.scrollTop();
        }
      },

    checkZgody(length) {
      let odp = {};      
      for (let i = 0; i < length; i++) {
        odp = this.validateSingleZgoda(this.zgody[i], i);
        if (odp.status=='err') {
          this.errorMessage = odp.message;
          this.error = true;
          return false;
        }               
      } 
      return true;
    },

    checkOsw(length) {      
      let odp = {};      
      for (let i = 0; i < length; i++) {
        odp = this.validateSingleOsw(this.oswiadczenia[i], i);
        if (odp.status=='err') {
          this.errorMessage = odp.message;
          this.error = true;
          return false;
        }               
      } 
      return true;
    },

    validateSingleZgoda(zgoda, key)
    {
      if (zgoda.wymagaj>0) {
        // wymagana zgoda dane:
        if (zgoda.checked == false) return { status: 'err', message: 'Wymagane zaznaczenie zgody' }; 
      }
      return { status: 'ok' };
    }, 

    validateSingleOsw(osw, key)
    {
      if (osw.wymagaj>0) {
        // wymagane dane:
        if (this.oswiadczenia[key].checked == false) return { status: 'ok' };
        if (!(this.oswiadczenia[key].danepacName)) return { status: 'err', message: 'Podaj imię i nazwisko osoby upoważnionej.' }; 
        if (this.oswiadczenia[key].danpacType === 'podaję PESEL' && (!(this.oswiadczenia[key].danepacPesel))) return { status: 'err', message: 'Podaj PESEL osoby upoważnionej.' }; 
        if (this.oswiadczenia[key].danpacType === 'podaję datę urodzenia' && (!(this.oswiadczenia[key].danepacDataur))) return { status: 'err', message: 'Podaj datę urodzenia osoby upoważnionej.' };         
      }       
      return { status: 'ok' };
    }, 

    findIndexOf(array, value)
    {
      for (let i = 0; i < array.length; i++) {      
        if (array[i].id == value) { return i;
        }
      }
      return false;
    },

    sendForm() {
      this.sending = true;

      const data = {
        pacjent: this.pacjent,
        formId: this.formId,
        placId: this.placowka.id,        
        upowazniony: this.getUpowazniony(),
        zgody: this.zgody,
        oswiadczenia: this.oswiadczenia,
      };

       this.$api
        .postFile(`/formularz/sendform`, data)
        .then(response => {
            this.placowka = false;            
            this.token = response.data.token;            
            this.openpdfbox = true;
            this.sending = false;
            })
        .catch(error => { console.log(error); this.sending = false; this.showSnackBar('Coś poszło nie tak...'); });
    },
    downloadPdf(token) {      
      this.sending = true;
      this.$api
        .postFile(`/downloadform/${token}`, {}, {responseType: 'blob'})
        .then(response => {
            this.pdf = response.data;
            this.downloaded = true;          
            this.getPdf(response.data);
            })
        .catch(error => { console.log(error); this.sending = false; this.showSnackBar('Coś poszło nie tak...'); });
    },
    getPdf(pdf) {
       const url = window.URL.createObjectURL(new Blob([pdf], {type: 'application/pdf'}));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'zgody_pacjenta.pdf');
            document.body.appendChild(link);
            link.click();
            this.downloaded = true;
            setTimeout(function(){
            // For Firefox it is necessary to delay revoking the ObjectURL
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            }
            , 500);
    },
    showSnackBar(comment) {
      this.errorMessage = comment;
      this.error = true;
    },
     placSelected() {
       this.loading = true;
       this.$api
      .getData(`/formularz/getform/${this.placowka.id}`)
      .then(response => {
          let count = response.data.formularze.length;
          if (count === 0) {
            console.log('brak formularzy');
            this.errorMessage = 'Brak formularzy';
            this.error = true;
          } else if (count === 1) {
            this.formId = response.data.formularze[0].form_id;
            this.formName = response.data.formularze[0].form_nazwa;
            this.zgody = response.data.formularze[0].zgody;
            this.oswiadczenia = this.setdanpacType(response.data.formularze[0].oswiadczenia);
            this.wymagane = response.data.formularze[0].wymagane;
            if (response.data.peselRequired == '2') this.peselRequired = true;              

          } else if (count > 1) {
            console.log('WYBOR FORMULARZA');
          }

          this.currentCity = response.data.currentCity;
          this.currentDate = response.data.currentDate;
          this.loading = false;
          })
      .catch(error => { console.log(error); this.loading = false; this.showSnackBar('Coś poszło nie tak...');

        } );
     },

    setdanpacType(oswiadczenia) {
      let output = [];
      oswiadczenia.forEach(obj => {
        obj.danpacType = 'podaję PESEL';
        output.push(obj);
      });
      return output;
    },

     returnToSelect() {
       this.placowka = false;
     },
     czyTypPesel(typ) {
       if (typ === 'podaję PESEL') { this.danepacDataur = ''; return true };
       this.danepacPesel = '';
       return false;
     },
     handleCity(val) {
        this.pacjent.miasto = val.nazw;
        this.pacjent.miastoId = val.id;
      },
      handleDataur(val) {
        console.log(val.id);
        console.log(val.dataur);
        this.oswiadczenia[val.id].danepacDataur = val.dataur;
      },
      save (date) {
        this.$refs.menu.save(date);
      },
   },

};
</script>
